const home = {
  path: 'home',
  component: resolve => require(['@/pages/admin/merchant/signing/home'], resolve),
}

export default home
